export default "__VITE_ASSET__CkVXEkCV__"